<template>
  <div>
    {{filter.values.radius}} <b>{{filter.values.unit.label}}</b> around {{filter.values.latlon.split(',').join(', ')}}
  </div>
</template>
<script>
  export default {
    props: {
      filter: Object
    },
    name: 'withinParams'
  }
</script>
<style>
</style>
